import Vue from "vue"
import App from "./App.vue"
import vuetify from "./plugins/vuetify"
import VueCookies from "vue-cookies"
import router from "./router"
import store from "./store"
import axios from "./plugins/axios"
import initSentry from "./plugins/sentry"
import VueLuxon from "vue-luxon"

Vue.config.productionTip = false

Vue.use(axios)
Vue.use(VueLuxon, {
  templates: {
    tz_med: {
      zone: "local",
      format: "med"
    },
    tz_date_med: {
      zone: "local",
      format: "date_med"
    },
    tz_date_full: {
      zone: "local",
      format: "date_full"
    }
  },
  input: {
    zone: "Australia/Melbourne",
    format: "iso"
  },
  output: {
    zone: "Australia/Melbourne",
    format: {
      year: "numeric",
      month: "long",
      day: "numeric"
    }
  }
})
Vue.use(VueCookies, { expires: "1d" })
document.title = "Nexus IOS Scan Analyzer"

initSentry()

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App)
}).$mount("#app")
